





















































































































import moment from 'moment'
import { Component, Ref, Vue } from 'vue-property-decorator'
import ListView from '@/components/ListView.vue'
import ShopAutocomplete from '@/components/ShopAutocomplete.vue'
import DateSelect from '@/components/DateSelect.vue'
import CSVExportBtn from '@/components/CSVExport.vue'
import { formatDateForDisplay } from '@/utils'

import { ReservationLog, ReservationLogUpdatedField } from '@/types/reservation'

@Component({
  components: {
    ListView,
    ShopAutocomplete,
    DateSelect,
    CSVExportBtn,
  },
})
export default class ReserveLogList extends Vue {
  filterDefinition = {
    userType: { type: String, default: null },
    shop: { type: String, default: null },
    isDeleted: { type: Boolean, default: null },
    dateFrom: { type: String, default: null },
    dateTo: { type: String, default: null },
    updatedFrom: { type: String, default: null },
    updatedTo: { type: String, default: null },
  }
  @Ref() readonly listView!: ListView

  get staffLoggedIn(): boolean {
    return this.$store.getters.staffLoggedIn
  }
  get csvHeaders() {
    const t = this.$t.bind(this)
    const locale = this.$i18n.locale
    return [
      {
        key: 'editor.username',
        label: String(t('reservationLog.csv.updater')),
      },
      { key: 'data.id', label: String(t('reservationLog.csv.reservationId')) },
      {
        key: 'data.isRemoved',
        label: String(t('reservationLog.csv.deletedFlag')),
      },
      { key: 'data.shopCode', label: String(t('reservationLog.csv.shopCode')) },
      { key: 'data.shopName', label: String(t('reservationLog.csv.shopName')) },
      {
        key: (item: ReservationLog) =>
          formatDateForDisplay(item.data?.date, locale) || '',
        label: String(t('reservationLog.csv.visitDate')),
      },
      { key: 'data.time', label: String(t('reservationLog.csv.visitTime')) },
      {
        key: 'data.familyName',
        label: String(t('reservationLog.csv.familyName')),
      },
      {
        key: 'data.givenName',
        label: String(t('reservationLog.csv.givenName')),
      },
      ...(this.$i18n.locale === 'ja'
        ? [
            {
              key: 'data.familyNameKana',
              label: String(t('reservationLog.csv.familyNameKana')),
            },
            {
              key: 'data.givenNameKana',
              label: String(t('reservationLog.csv.givenNameKana')),
            },
          ]
        : []),
      { key: 'data.userEmail', label: String(t('reservationLog.csv.appId')) },
      {
        key: 'data.customerCode',
        label: String(t('reservationLog.csv.customerCode')),
      },
      {
        key: 'data.phoneNumber',
        label: String(t('reservationLog.csv.phoneNumber')),
      },
      {
        key: 'data.reservingWayText',
        label: String(t('reservationLog.csv.reservationRoute')),
      },
      { key: 'data.menuName', label: String(t('reservationLog.csv.menuName')) },
      {
        key: 'data.stateText',
        label: String(t('reservationLog.csv.visitStatus')),
      },
      {
        key: 'data.attendedStaffCode',
        label: String(t('reservationLog.csv.attendedStaffCode')),
      },
      {
        key: 'data.attendedStaffName',
        label: String(t('reservationLog.csv.attendedStaffName')),
      },
      {
        key: 'data.operationHistory.treatmentStaffCode',
        label: String(t('reservationLog.csv.treatmentStaffCode')),
      },
      {
        key: 'data.operationHistory.treatmentStaffName',
        label: String(t('reservationLog.csv.treatmentStaffName')),
      },
      {
        key: 'data.operationHistory.dyeingStaffCode1',
        label: String(t('reservationLog.csv.dyeingStaffCode1')),
      },
      {
        key: 'data.operationHistory.dyeingStaffName1',
        label: String(t('reservationLog.csv.dyeingStaffName1')),
      },
      {
        key: 'data.operationHistory.dyeingStaffCode2',
        label: String(t('reservationLog.csv.dyeingStaffCode2')),
      },
      {
        key: 'data.operationHistory.dyeingStaffName2',
        label: String(t('reservationLog.csv.dyeingStaffName2')),
      },
      {
        key: 'data.operationHistory.shampooStaffCode',
        label: String(t('reservationLog.csv.shampooStaffCode')),
      },
      {
        key: 'data.operationHistory.shampooStaffName',
        label: String(t('reservationLog.csv.shampooStaffName')),
      },
      {
        key: (item: ReservationLog) =>
          item.updatedFields
            ?.map(x =>
              String(
                t('reservationLog.text.fieldChange', {
                  label: x.label,
                  oldText: x.oldText,
                  newText: x.newText,
                })
              )
            )
            .join(', '),
        label: String(t('reservationLog.csv.changedFields')),
      },
      {
        key: prevValue('isRemoved'),
        label: String(t('reservationLog.csv.prevDeletedFlag')),
      },
      {
        key: prevValue('shop'),
        label: String(t('reservationLog.csv.prevShop')),
      },
      {
        key: (item: ReservationLog) => {
          return formatDateForDisplay(item.data?.date, locale) || ''
        },
        label: String(t('reservationLog.csv.prevVisitDate')),
      },
      {
        key: prevValue('time'),
        label: String(t('reservationLog.csv.prevVisitTime')),
      },
      {
        key: prevValue('state'),
        label: String(t('reservationLog.csv.prevVisitStatus')),
      },
      {
        key: prevValue('reservedByd'),
        label: String(t('reservationLog.csv.prevReservationRoute')),
      },
      {
        key: prevValue('attendedStaff'),
        label: String(t('reservationLog.csv.prevAttendedStaff')),
      },
      {
        key: prevValue('staff'),
        label: String(t('reservationLog.csv.prevTreatmentStaff')),
      },
      {
        key: prevValue('shampooDyestuff'),
        label: String(t('reservationLog.csv.prevShampooStaff')),
      },
      {
        key: (item: ReservationLog) => {
          return formatDateForDisplay(item.created, locale) || ''
        },
        label: String(t('reservationLog.csv.updatedDate')),
      },
      {
        key: (item: ReservationLog) => extractTime(item.created),
        label: String(t('reservationLog.csv.updatedTime')),
      },
    ]
  }
  get csvFetch() {
    return () => this.$api.reservations().list(this.listView.query)
  }

  get headers() {
    return [
      {
        text: this.$t('reservationLog.text.updatedDateTime'),
        value: 'created',
      },
      {
        text: this.$t('reservationLog.text.updater'),
        value: 'editor.username',
      },
      {
        text: this.$t('reservationLog.text.updatedFields'),
        value: 'updatedFields',
      },

      {
        text: this.$t('reservationLog.text.reservationId'),
        value: 'data.id',
        width: 80,
      },
      {
        text: this.$t('reservationLog.text.deleted'),
        value: 'data.isRemoved',
        width: 80,
      },

      {
        text: this.$t('reservationLog.text.shopCode'),
        value: 'data.shopCode',
        width: 60,
      },
      {
        text: this.$t('reservationLog.text.shopName'),
        value: 'data.shopName',
        width: 200,
      },
      {
        text: this.$t('reservationLog.text.visitDate'),
        value: 'data.date',
        width: 100,
      },
      {
        text: this.$t('reservationLog.text.visitTime'),
        value: 'data.time',
        width: 80,
      },
      {
        text: this.$t('reservationLog.text.state'),
        value: 'data.stateText',
        width: 100,
      },

      {
        text: this.$t('reservationLog.text.customerCode'),
        value: 'data.customerCode',
        width: 100,
      },
      { text: this.$t('reservationLog.text.appId'), value: 'data.userEmail' },
      ...(this.$i18n.locale === 'ja'
        ? [
            {
              text: this.$t('reservationLog.text.reserverName'),
              value: 'data.fullNameKana',
            },
          ]
        : []),
      {
        text: this.$t('reservationLog.text.reservationRoute'),
        value: 'data.reservingWayText',
        width: 150,
      },
    ]
  }
  updatedFields(fields: ReservationLogUpdatedField[]) {
    if (fields.length === 0)
      return String(this.$t('reservationLog.text.newlyCreated'))
    return fields
      .map(x =>
        String(
          this.$t('reservationLog.text.fieldChange', {
            label: x.label,
            oldText: x.oldText,
            newText: x.newText,
          })
        )
      )
      .join(', ')
  }

  filter: null | Record<string, any> = null

  // @Watch('$route.query')
  // onQueryChanged() {
  //   this.query = filterUtil.parseQueryDict(this.$route.query)
  // }

  updateQuery() {
    if (this.filter !== null) this.listView.updateQuery(this.filter)
  }
}

const extractTime = (value: string | undefined) =>
  value ? moment(value).format('HH:mm') : ''

const prevValue = (fieldName: string) => (item: ReservationLog) => {
  const found: any = item.updatedFields?.find(x => x.name == fieldName)
  if (found) {
    if (Array.isArray(found.oldText)) return found.oldText[1]
    return found.oldText
  }
  return (
    item.data[fieldName + 'Text'] ||
    item.data[fieldName + 'Name'] ||
    item.data[fieldName]
  )
}
